import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var styles = {"sizeTile":"sizeTile-3i47L","sizeTileActive":"sizeTileActive-3i47L","sizeTileDisabled":"sizeTileDisabled-3i47L"};

var _excluded = ["className", "isDisabled", "isSelected", "text"];
var SizeTile = _ref => {
  var {
      className,
      isDisabled,
      isSelected,
      text
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: cs(styles.sizeTile, {
      [styles.sizeTileActive]: isSelected,
      [styles.sizeTileDisabled]: isDisabled,
      [className]: className
    })
  }, otherProps), text, isDisabled && /*#__PURE__*/React.createElement("span", {
    className: "lll-hidden-visually"
  }, "\xA0(not available)"));
};
var propTypes = {
  className: PropTypes.string,
  /** Whether to show in a disabled state */
  isDisabled: PropTypes.bool,
  /** Whether to show in a selected state */
  isSelected: PropTypes.bool,
  text: PropTypes.string.isRequired
};
var defaultProps = {
  className: '',
  isDisabled: false,
  isSelected: false
};
SizeTile.propTypes = propTypes;
SizeTile.defaultProps = defaultProps;

export { SizeTile, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
